import { definedMap } from "@glideapps/ts-necessities";

import { ComponentBuilder } from "../components";
import { SummaryArrayContentDescription, getNumberToTruncateTo } from "./summary-array-screen";
import { arrayScreenName, TableGlideType, makeTableRef } from "../description";
import { SerializedComponent } from "../../components/SerializedApp";
import { summaryForTableRef } from "../builder-utils";
import { getGroupByColumn, InlineListBuild } from "./array-content";
import { withColumnFormat } from "../formulas";

export function handleTruncationAndGrouping(
    builder: ComponentBuilder,
    desc: SummaryArrayContentDescription,
    table: TableGlideType,
    arrayData: SerializedComponent,
    inlineListBuild: InlineListBuild | undefined,
    caption: SerializedComponent | undefined,
    roundTo: number,
    supportGrouping: boolean,
    buildUI: (
        listData: SerializedComponent,
        isGrouped: SerializedComponent,
        args: { [key: string]: SerializedComponent | undefined }
    ) => SerializedComponent
): SerializedComponent {
    const { b } = builder;

    const numToTruncate = getNumberToTruncateTo(desc, inlineListBuild !== undefined, roundTo, supportGrouping);

    const groupByColumn = getGroupByColumn(desc, table, supportGrouping);
    if (groupByColumn !== undefined) {
        arrayData = b.group(arrayData, b.getProperty(groupByColumn.name, b.getContext, table));
    }
    const isGrouped = b.constant(groupByColumn !== undefined);

    if (numToTruncate === undefined) {
        if (groupByColumn !== undefined) {
            arrayData = b.map(
                arrayData,
                b.object({
                    key: b.getNonTableProperty("key", b.getContext),
                    name: withColumnFormat(builder, b.getNonTableProperty("key", b.getContext), table, groupByColumn),
                    items: b.getNonTableProperty("items", b.getContext),
                })
            );
        }
        return buildUI(arrayData, isGrouped, {});
    }

    const fullArray = b.getVariable("fullArray");
    const listData = b.builtinCall("ListTake", [fullArray, b.constant(numToTruncate)]);
    const pushScreen = builder.makePushScreen(
        arrayScreenName(makeTableRef(table)),
        b.getVariable("groupName"),
        undefined,
        fullArray
    );
    const onSeeAll = definedMap(pushScreen, p =>
        b.if(b.isLessThan(b.constant(numToTruncate), b.listLength(fullArray)), p)
    );

    if (groupByColumn !== undefined && onSeeAll !== undefined) {
        arrayData = b.map(
            arrayData,
            b.let(
                [
                    ["fullArray", b.getNonTableProperty("items", b.getContext)],
                    [
                        "groupName",
                        withColumnFormat(builder, b.getNonTableProperty("key", b.getContext), table, groupByColumn),
                    ],
                ],
                b.object({
                    key: b.getNonTableProperty("key", b.getContext),
                    name: b.getVariable("groupName"),
                    items: listData,
                    onSeeAll,
                })
            )
        );
        return buildUI(arrayData, isGrouped, {});
    } else {
        return b.let(
            [
                ["fullArray", arrayData],
                ["groupName", caption ?? summaryForTableRef(builder, table, desc, b.getContext)[0] ?? b.constant("")],
            ],
            buildUI(listData, isGrouped, { onSeeAll })
        );
    }
}
